import { render, staticRenderFns } from "./UccDataUpsell.vue?vue&type=template&id=058fba09"
import script from "./UccDataUpsell.vue?vue&type=script&lang=js"
export * from "./UccDataUpsell.vue?vue&type=script&lang=js"
import style0 from "./UccDataUpsell.vue?vue&type=style&index=0&id=058fba09&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports